import { FeatureFlags, insertIf, WorkflowType } from '@kindo/universal';
import { useFlag } from '@unleash/nextjs';

import WorkflowCatalogueCard from './WorkflowCatalogueCard';

interface WorkflowCatalogueProps {
  selectWorkflowType: (type: WorkflowType) => void;
}

const WorkflowCatalogue = ({ selectWorkflowType }: WorkflowCatalogueProps) => {
  const canUseMerge = useFlag(FeatureFlags.MERGE_INTEGRATION);
  return (
    <div
      className="flex flex-1 flex-col gap-6"
      data-testid="workflow-builders-container"
    >
      {[
        ...insertIf(canUseMerge, WorkflowType.TRIGGERED),
        WorkflowType.MANUAL,
        WorkflowType.CHATBOT
      ].map((type: WorkflowType) => (
        <WorkflowCatalogueCard
          key={type}
          onBuildClick={selectWorkflowType}
          workflowType={type}
        />
      ))}
    </div>
  );
};

export default WorkflowCatalogue;
